import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import './styles/fonts.css'
import './styles/tokens.css'
import './styles/base.css'
import { routes } from './router'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

// hydrationData tells the router it is picking up a server render, so the matched route
// is rendered on the very first pass. Without it the first client render has no active
// route and hydration mismatches against the prerendered markup. No route has a loader,
// so there is no data to pass.
const router = createBrowserRouter(routes, { hydrationData: { loaderData: {} } })

const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)

// Every route ships as prerendered HTML (see scripts/prerender.mjs), so the normal path
// is hydration. createRoot is the fallback for `vite dev`, where the container is empty.
if (container.hasChildNodes()) {
  hydrateRoot(container, app)
} else {
  createRoot(container).render(app)
}
